import React, { useEffect, useMemo, lazy, Suspense, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiCall, { apiCall2 } from "../components/Api/api";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import OperatorSekeltonProfile from "components/common/Skeleton/safariTabSekelton/OperatorSekeltonProfile";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
import MobileNoVerificationModal from "components/common/mobilenoverification/MobileNoVerificationModal";
const SafariTourOperatorBanner = lazy(() => import("../components/safaritouroperator/SafariTourOperatorBanner"));
const OperatorProfile = lazy(() => import("../components/safaritouroperator/header/OperatorProfile"));
const SafariTourOperatorsDetails = lazy(() => import("../components/safaritouroperator/SafariTourOperatorsDetails"));





const SafariTourOperator = () => {
  const { slug, tabslug } = useParams();
  const { toggleMobileVerify, mobileVerifyDispatch } = useMobileVerifyContext();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const prevUrlRef = useRef(); // for profile fetch
  const prevUrlSafariRef = useRef(); // for share safari fetch
  const prevUrlPackageRef = useRef(); // for share package fetch
  const prevUrlParkRef = useRef(); // for share package fetch
  const prevUrlReviewRef = useRef(); // for share package fetch
  const { operatorProfileView, loadingOpProfile,
    pageIndex,
    pageIndexOp,
    pageIndexParks,
    pageIndexReviews,
    filters,
    activeTab,
    operatorProfileDispatch } = useOperatorProfileContext();

useEffect(() => {
  // Ensure tabslug is defined and differs from the current activeTab
  if (tabslug && tabslug !== activeTab) {
    operatorProfileDispatch({
      type: "SET_ACTIVE_TAB",
      payload: tabslug,
    });
  }
}, [tabslug, activeTab, operatorProfileDispatch]);

  //update url
  useEffect(() => {
    if (!activeTab) return;

    // Only update if URL doesn't match
    if (tabslug !== activeTab) {
      navigate(`/operator/${slug}/profile/${activeTab}`, { replace: true });
    }
  }, [activeTab, slug, tabslug, navigate]);

  //operator view
  useEffect(() => {
    const currentUrl = `operator/${slug}`
    const opertaorProfile = async () => {
      if (operatorProfileView?.slug === slug) return;
      try {
        operatorProfileDispatch({ type: "SET_OP_PROFILE_DATA_LOADING", payload: true });
        const response = await apiCall({
          url: currentUrl,
        });

        if (response.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            operatorProfileDispatch({
              type: "SET_OP_PROFILE_DATA_ERROR",
              payload: errors,
            });
            console.error(errors)
          } else {
            const profileData = response?.data?.data;
            operatorProfileDispatch({ type: 'SET_OP_PROFILE_DATA', payload: profileData });
          }
        }
      } catch (error) {
        // console.error("An error occurred while fetching user profile:", error);
        handleError(error, logout, navigate);
      } finally {
        operatorProfileDispatch({ type: "SET_OP_PROFILE_DATA_LOADING", payload: false });
      }
    };
    if (currentUrl && currentUrl !== prevUrlRef.current) {
      prevUrlRef.current = currentUrl;
      opertaorProfile();
    }
  }, [slug]);

  // for share safari
  useEffect(() => {
    if (!operatorProfileView?.urls?.sharedsafari) return;

    const query = pageIndex ? `?page=${pageIndex}` : "";
    const currentUrl = `${operatorProfileView.urls.sharedsafari}${query}`;

    // Prevent duplicate API call
    if (prevUrlSafariRef.current === currentUrl) return;

    prevUrlSafariRef.current = currentUrl;

    const fetchOperatorSharedSafari = async () => {

      try {
        // console.count()
        operatorProfileDispatch({ type: "SET_OPERATOR_SF_DATA_LOADING", payload: true });


        const response = await apiCall2({
          url: currentUrl
        });

        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response?.data;

        if (apiData?.errors) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_SF_DATA_ERROR",
            payload: apiData.errors,
          });
          return;
        }

        const safariData = apiData?.sharedsafari?.data;
        const summary = apiData?.sharedsafari?.summary;
        if (pageIndex === 1) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_SHARED_SAFARI_DATA",
            payload: safariData,
          });
        } else {
          operatorProfileDispatch({
            type: "APPEND_OPERATOR_SHARED_SAFARI_DATA",
            payload: safariData,
          });
        }

        operatorProfileDispatch({
          type: "SHARED_OPERATOR_SHARED_SAFARI_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      } finally {
        operatorProfileDispatch({ type: "SET_OPERATOR_SF_DATA_LOADING", payload: false });
      }
    };


    prevUrlSafariRef.current = currentUrl;
    fetchOperatorSharedSafari();

  }, [operatorProfileView?.urls?.sharedsafari, pageIndex]);

  // for packages
  useEffect(() => {
    if (!operatorProfileView?.urls?.packages) return;

    const query = pageIndexOp ? `?page=${pageIndexOp}` : "";
    const currentUrl = `${operatorProfileView.urls.packages}${query}`;

    // Prevent duplicate API call
    if (prevUrlPackageRef.current === currentUrl) return;

    prevUrlPackageRef.current = currentUrl;

    const fetchOperatorPackage = async () => {


      try {
        // console.count()
        operatorProfileDispatch({ type: "SET_OPERATOR_PAC_DATA_LOADING", payload: true });


        const response = await apiCall2({
          url: currentUrl
        });

        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response?.data;

        if (apiData?.errors) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_PAC_DATA_ERROR",
            payload: apiData.errors,
          });
          return;
        }

        const safariData = apiData?.packages?.data;
        const summary = apiData?.packages?.summary;
        if (pageIndexOp === 1) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_PACKAGE_DATA",
            payload: safariData,
          });
        } else {
          operatorProfileDispatch({
            type: "APPEND_OPERATOR_PACKAGE_DATA",
            payload: safariData,
          });
        }

        operatorProfileDispatch({
          type: "SHARED_OPERATOR_PACKAGE_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      } finally {
        operatorProfileDispatch({ type: "SET_OPERATOR_PAC_DATA_LOADING", payload: false });
      }
    };


    prevUrlPackageRef.current = currentUrl;
    fetchOperatorPackage();

  }, [operatorProfileView?.urls?.packages, pageIndexOp]);

  // for Park
  useEffect(() => {
    if (!operatorProfileView?.urls?.parks) return;

    const query = pageIndexParks ? `?page=${pageIndexParks}&pageSize=12` : "";
    const currentUrl = `${operatorProfileView.urls.parks}${query}`;

    // Prevent duplicate API call
    if (prevUrlParkRef.current === currentUrl) return;

    prevUrlParkRef.current = currentUrl;

    const fetchOperatorParks = async () => {


      try {
        // console.count()
        operatorProfileDispatch({ type: "SET_OPERATOR_PARK_DATA_LOADING", payload: true });


        const response = await apiCall2({
          url: currentUrl
        });

        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response?.data;

        if (apiData?.errors) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_PARK_DATA_ERROR",
            payload: apiData.errors,
          });
          return;
        }

        const safariData = apiData?.parks?.data;
        const summary = apiData?.parks?.summary;
        if (pageIndexParks === 1) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_PARK_DATA",
            payload: safariData,
          });
        } else {
          operatorProfileDispatch({
            type: "APPEND_OPERATOR_PARK_DATA",
            payload: safariData,
          });
        }

        operatorProfileDispatch({
          type: "SHARED_OPERATOR_PARK_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      } finally {
        operatorProfileDispatch({ type: "SET_OPERATOR_PARK_DATA_LOADING", payload: false });
      }
    };


    prevUrlParkRef.current = currentUrl;
    fetchOperatorParks();

  }, [operatorProfileView?.urls?.parks, pageIndexParks]);

  // for Review
  useEffect(() => {
    if (!operatorProfileView?.review_url?.reviews) return;
    const params = new URLSearchParams();
    if (pageIndexReviews) {
      params.append("page", pageIndexReviews);
      params.append("pageSize", 12);
    }
    const validSortByOptions = ["newest", "oldest", "highest", "lowest"];
    if (validSortByOptions.includes(filters?.sort_by)) {
      params.append("sort_by", filters.sort_by);
    }

    if (Number.isInteger(filters?.park_id) && filters.park_id > 0) {
      params.append("park_id", filters.park_id);
    }
    const currentUrl = `${operatorProfileView.review_url.reviews}?${params.toString()}`;

    // Prevent duplicate API call
    if (prevUrlReviewRef.current === currentUrl) return;
    prevUrlReviewRef.current = currentUrl;

    const fetchOperatorReviews = async () => {
      try {
        // console.count()
        operatorProfileDispatch({ type: "SET_OPERATOR_REVIEW_DATA_LOADING", payload: true });


        const response = await apiCall2({
          url: currentUrl
        });

        if (response?.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        const apiData = response?.data;

        if (apiData?.errors) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_REVIEW_DATA_ERROR",
            payload: apiData.errors,
          });
          return;
        }

        const safariData = apiData?.reviews?.data;
        const summary = apiData?.reviews?.summary;
        if (pageIndexReviews === 1) {
          operatorProfileDispatch({
            type: "SET_OPERATOR_REVIEW_DATA",
            payload: safariData,
          });
        } else {
          operatorProfileDispatch({
            type: "APPEND_OPERATOR_REVIEW_DATA",
            payload: safariData,
          });
        }

        operatorProfileDispatch({
          type: "SHARED_OPERATOR_REVIEW_SUMMARY",
          payload: {
            total: summary.total,
            page: summary.page,
            pageSize: summary.pageSize,
            total_page: summary.total_page,
          },
        });

      } catch (error) {
        handleError(error, logout, navigate);
      } finally {
        operatorProfileDispatch({ type: "SET_OPERATOR_REVIEW_DATA_LOADING", payload: false });
      }
    };


    prevUrlReviewRef.current = currentUrl;
    fetchOperatorReviews();

  }, [operatorProfileView?.review_url?.reviews, pageIndexReviews, filters]);
  //for operator parks Dropdown
  useEffect(() => {
    
    const currentUrl = `operator/${slug}/operator-park-dropdown?pageSize=12`
    const opertaorParks = async () => {
      if (operatorProfileView?.slug === slug) return;
      try {
        const response = await apiCall({
          url: currentUrl,
        });

        if (response.status !== 200) {
          throw new Error(`Unexpected status code: ${response.status}`);
        }

        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            console.error(errors)
          } else {
            const parksOptions = response?.data?.parks?.data || [];
            
            const options = parksOptions?.map((item) => ({
              label: item.title,
              value: item.id,
              quotation_form_note: item?.quotation_form_note,
              slug: item?.slug
            }));
            operatorProfileDispatch({
              type: "SET_OPERATOR_PARK_OPTIONS_DATA",
              payload: options,
            });
          }
        }
      } catch (error) {
        // console.error("An error occurred while fetching user profile:", error);
        handleError(error, logout, navigate);
      } finally {

      }
    };
    if (currentUrl && currentUrl !== prevUrlRef.current) {
      prevUrlRef.current = currentUrl;
      opertaorParks();
    }
  }, [slug]);

  const memoizedOperatorViewData = useMemo(() => operatorProfileView, [operatorProfileView]);

  const handleClose = () => {
    mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: false });
  }

  return (
    <>

      <Suspense fallback={null}>
        <SafariTourOperatorBanner />
      </Suspense>
      <Suspense fallback={<OperatorSekeltonProfile />}>
        {loadingOpProfile ? <OperatorSekeltonProfile /> : <OperatorProfile operatorsviewdata={memoizedOperatorViewData} />}
      </Suspense>
      <Suspense fallback={null}>
        <SafariTourOperatorsDetails />
      </Suspense>
       {toggleMobileVerify && <MobileNoVerificationModal  handleSubmit={handleClose} title="You need to verify your phone number"/>}
    </>
  );
}

export default SafariTourOperator;
